const status = {
  startingSoon: 'startingSoon',
  ongoing: 'ongoing',
  finished: 'finished',
  watching: 'watching',
};

const conferenceStatusClassNameColor: { [index: string]: any } = {
  ongoing: 'ongoing-color',
  watching: 'watching-color',
  startingSoon: 'startingSoon-color',
  finished: 'finished-color',
};

const conferenceColorStatusMap: { [index: string]: string } = {
  ongoing: 'text-warning-02',
  watching: 'focus-success',
  'starting soon': 'hover-primary',
  finished: 'text-01',
};

export const ConferenceStatusUtils = {
  status,
  conferenceStatusClassNameColor,
  conferenceColorStatusMap,
};
